import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';
import { holdPls } from 'app/utils/time/timing-utils';

@Component({
  selector: 'app-itinerary-animation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './itinerary-animation.component.html',
  styleUrl: './itinerary-animation.component.scss'
})
export class ItineraryAnimationComponent {
  @Input() isGeneric: boolean = false;

  ngAfterViewInit() {
    this.handleAnimateDocument()
  };

  async handleAnimateDocument() {
    await holdPls(300);
    const timeline = anime.timeline({
      easing: 'easeOutQuad',
      autoplay: true,
      loop: false
    });

    timeline.add({
      targets: '#main-svg',
      opacity: [0, 1],
      duration: 50,
    });

    timeline.add({
      targets: '#page-el',
      opacity: [0, 1],
      scale: [0.8, 1],
      duration: 250,
      delay: anime.stagger(100),
      easing: 'spring(1, 80, 10, 0)'
    });

    timeline.add({
      targets: '#animation-els *',
      opacity: [0, 1],
      duration: 500,
      delay: anime.stagger(40),
      easing: 'spring(1, 80, 10, 0)'
    }, 100);
  }


}
